import React, { useState, useMemo, useEffect, useRef } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { useDropzone } from "react-dropzone";
// import "./Atest.css";
import { InfinitySpin } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import { putData } from "../../FetchNodeServices";
import Select from "react-select";
import { useSelector } from "react-redux";
import { ChromePicker } from "react-color";
import AlertMessages from "../Mains/Alerts";

const Branding = () => {
  const [isActivated, setActivated] = useState(true);
  const [fullwidthwrapper, setfullwidthwrapper] = useState();
  const [customerBranding, setCustomerBranding] = useState("");
  const [surveyDomain, setSurveyDomain] = useState("");
  const [surveyDomainError, setSurveyDomainError] = useState("");
  const [isDataChanged, setDataChanged] = useState(false);
  const [HelpdeskEmail, setHelpdeskEmail] = useState("");
  const [helpdeskEmailError, setHelpdeskEmailError] = useState("");
  const [termslink, setTermsLink] = useState("");
  const [privacyLink, setPrivacyLink] = useState("");
  const [primaryColor, setPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const [showPrimaryColorPicker, setShowPrimaryColorPicker] = useState(false);
  const [showSecondaryColorPicker, setShowSecondaryColorPicker] = useState(false);
  const [primaryTypeface, setPrimaryTypeface] = useState(null);
  const [primaryTypefaceList, setPrimaryTypefaceList] = useState([]);
  const [image, setImage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [alerts, setAlerts] = useState([]);
  let navigate = useNavigate();
  const inputRef = useRef(null);
  const pickerRef = useRef(null);

  const customer = useSelector((state) => state.user.users[0]);
  const user = useMemo(() => customer?.userId || "", [customer]);
  const account = useMemo(() => customer?.accountId || "", [customer]);

  // const [isVisible, setIsVisible] = useState(false);
  const handleToggle = () => {
    setActivated(!isActivated);
    setfullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target) && pickerRef.current && !pickerRef.current.contains(event.target)) {
      setShowSecondaryColorPicker(false);
      setShowPrimaryColorPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const toggleVisibility = (event) => {
  //   setIsVisible(!isVisible);
  //   setCustomerBranding(event.target.value);
  //   setDataChanged(true);
  // };

  useEffect(() => {
    const fetchGoogleFonts = async () => {
      try {
        const response = await fetch("https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyCsDW2J6_A5rmQskjYEFdHyyNeY8-lUaHQ");
        if (response.ok) {
          const data = await response.json();
          if (data.items) {
            const fonts = data.items.map((font) => ({
              value: font.family,
              label: font.family,
            }));
            setPrimaryTypefaceList(fonts);
          }
        } else {
          throw new Error("Failed to fetch Google Fonts");
        }
      } catch (error) {
        // console.error("Error fetching Google Fonts:", error);
        setAlerts([{ variant: "danger", heading: "Error fetching Google Fonts." }]);
      }
    };

    fetchGoogleFonts();
  }, []);

  const isValidDomain = (domain) => {
    const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
    return domainRegex.test(domain);
  };

  const handleInputChange = (event, setter) => {
    const { value } = event.target;
    if (setter === setSurveyDomain) {
      if (isValidDomain(value)) {
        setSurveyDomainError("");
      } else {
        setSurveyDomainError("Please enter a valid domain.");
      }
    }
    setter(value);
    setDataChanged(true);
  };
  const handleEmailChange = (event) => {
    const emailValue = event.target.value;
    const emailRegex = /^[a-zA-Z0-9_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(emailValue)) {
      setHelpdeskEmailError("Invalid email address");
    } else if (
      emailValue.split("@")[1].includes(".") &&
      emailValue.split("@")[1].split(".").length > 2
    ) {
      setHelpdeskEmailError("Email should not contain multiple periods after the domain.");
    } else {
      setHelpdeskEmailError(null); // Clear any previous errors
    }
    setHelpdeskEmail(emailValue);
    setDataChanged(true);
  };

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0 && acceptedFiles[0].type.startsWith("image/")) {
      const file = acceptedFiles[0];
      const reader = new FileReader();

      reader.onload = () => {
        setImage(reader.result);
        setDataChanged(true);
      };

      reader.readAsDataURL(file);
    } else {
      // alert("Please select a valid image file.");
      setAlerts([{ variant: "danger", heading: "Please select a valid image file." }]);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: "image/*" });

  const handleImageChange = (event) => {
    setImage({
      bytes: event.target.files[0],
      filename: URL.createObjectURL(event.target.files[0]),
    });
    setDataChanged(true);
  };

  const handleImagereset = () => {
    setImage("");
  };

  const handleSubmit = async () => {
    if (!isDataChanged) return;
    setIsLoading(true);
    var formData = {
      userId: user,
      accountId: account,
      customerBranding: customerBranding,
      surveyDomain: surveyDomain,
      helpDeskEmail: HelpdeskEmail,
      termAndConditionLink: termslink,
      privacyLink: privacyLink,
      primaryColorCode: primaryColor,
      secondaryColorCode: secondaryColor,
      surveyFont: primaryTypeface,
      logo: image,
    };
    let result = await putData("users/branding-details", formData);
    if (result) {
      // alert("User Added Successfully!");
      setIsLoading(false);
      // console.log("User updated Successfully!");
      setAlerts([{ variant: "success", heading: "Data saved successfully." }]);
      navigate("/manage-customer");
    } else {
      setAlerts([{ variant: "danger", heading: "error in adding data." }]);
    }
  };

  const handleClear = () => {
    setSurveyDomain("");
    setHelpdeskEmail("");
    setTermsLink("");
    setPrivacyLink("");
    setPrimaryColor("");
    setSecondaryColor("");
    setPrimaryTypeface("");
    setImage(null);
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        {isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center " style={{ zIndex: 1050 }}>
            <div className="p-5 rounded ">
              <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
            </div>
          </div>
        )}
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-people"></i> Customer Admin
              </li>
              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i>Branding
              </li>
            </ul>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>
          <div className="steps_box mb-3 fw-600">
            <div>
              <span className="step_count">1</span> Basic Details
            </div>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>
            <div>
              <span className="step_count ">2</span> Billing Details
            </div>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>
            <div>
              <span className="step_count active">3</span> Branding
            </div>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Customer Branding</label>
                    <select value={customerBranding} name="" id="" className="form-control" onChange={(event) => handleInputChange(event, setCustomerBranding)}>
                      <option value="0" selected>
                        No
                      </option>
                      <option value="1">Yes</option>
                    </select>
                  </div>
                </div>

                <div className="col-lg-6">
                  {customerBranding === "1" && (
                    <div className="form-group mb-4">
                      <label for="">Domain for survey</label>
                      <input
                        type="text"
                        value={surveyDomain}
                        className={`form-control ${surveyDomainError ? "is-invalid" : ""}`}
                        placeholder="Enter domain"
                        onChange={(event) => handleInputChange(event, setSurveyDomain)}
                      />
                      {surveyDomainError && <div className="invalid-feedback">{surveyDomainError}</div>}
                    </div>
                  )}
                </div>

                <div className="col-lg-6"></div>
                <div className="col-12">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="col-lg-12">
                        <div className="form-group mb-4">
                          <label for="">Upload Logo</label>
                          <div className="drop-zone">
                            {image ? (
                              <div className="image-preview-container">
                                <img src={image} alt="Uploaded" className="image-preview" />
                                <div onClick={handleImagereset} className="text-overlay  position-absolute ">
                                  <i className="bi bi-x fs-20"></i>
                                </div>
                              </div>
                            ) : (
                              <div className="dropzone">
                                <div {...getRootProps()} className="drop-zone__prompt fs-16 fw-500 text-dark">
                                  <input {...getInputProps()} onChange={handleImageChange} />
                                  <div className="text-center mb-3">
                                    <i className="bi bi-images fs-50 text-green"></i>
                                  </div>
                                  Drop your files here or <span className="text-green">browse</span>
                                  <br />
                                  <span className="text-grey fs-13"> Maximum size: 50MB</span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group mb-4">
                            <label htmlFor="">Helpdesk Email ID</label>
                            <input
                              type="text"
                              id="HelpdeskEmail"
                              value={HelpdeskEmail}
                              onChange={handleEmailChange}
                              className="form-control"
                            />
                            {helpdeskEmailError && <small className="text-danger">{helpdeskEmailError}</small>}

                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-4">
                            <label htmlFor="">Terms & Conditions Link</label>
                            <input
                              type="url"
                              value={termslink}
                              className="form-control"
                              placeholder="Enter URL"
                              onChange={(event) => handleInputChange(event, setTermsLink)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-4">
                            <label htmlFor="">Privacy Link</label>
                            <input
                              type="url"
                              value={privacyLink}
                              className="form-control"
                              placeholder="Enter URL"
                              onChange={(event) => handleInputChange(event, setPrivacyLink)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Primary Color Code</label>
                    {showPrimaryColorPicker && (
                      <div style={{ position: "relative" }}>
                        <div style={{ position: "absolute", top: "-250px", zIndex: 999 }} ref={pickerRef}>
                          <ChromePicker
                            color={primaryColor || "#FFFFFF"}
                            onChangeComplete={(color) => {
                              if (color) {
                                setPrimaryColor(color.hex);
                                setDataChanged(true);
                              }
                            }}
                          />
                        </div>
                      </div>
                    )}
                    <input
                      type="text"
                      value={primaryColor}
                      className="form-control"
                      placeholder="Enter hexacode"
                      onFocus={() => setShowPrimaryColorPicker(true)}
                      ref={inputRef}
                      style={{ textTransform: "uppercase" }}
                    // onChange={(event) => handleInputChange(event, setPrimaryColor)}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Secondary Color Code</label>
                    {showSecondaryColorPicker && (
                      <div style={{ position: "relative" }}>
                        <div style={{ position: "absolute", top: "-250px", zIndex: 999 }} ref={pickerRef}>
                          <ChromePicker
                            color={secondaryColor || "#FFFFFF"}
                            onChangeComplete={(color) => {
                              if (color) {
                                setSecondaryColor(color.hex);
                                setDataChanged(true);
                              }
                            }}
                          />
                        </div>
                      </div>
                    )}
                    <input
                      type="text"
                      value={secondaryColor}
                      className="form-control"
                      placeholder="Enter hexacode"
                      onFocus={() => setShowSecondaryColorPicker(true)}
                      ref={inputRef}
                      style={{ textTransform: "uppercase" }}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Primary Typeface</label>
                    <Select
                      options={primaryTypefaceList}
                      value={primaryTypefaceList.find((option) => option.value === primaryTypeface)}
                      onChange={(selectedOption) => {
                        setPrimaryTypeface(selectedOption.value);
                        setDataChanged(true);
                      }}
                      placeholder="Select Primary Typeface"
                      isSearchable
                      menuPlacement="top"
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between">
                <div className="button_group">
                  <Link to="/ebilling-detail">
                    <button type="button" className="btn btn-light text-grey me-3">
                      <i className="bi bi-chevron-left me-1"></i> Back
                    </button>
                  </Link>
                  {/* <button type="button" className="btn bg-danger-subtle text-danger" onClick={() => handleClear()}>
                    Clear Values
                  </button> */}
                </div>
                <div className="button_group">
                  {/* <Link to="/manage-customer"> */}
                  <button
                    type="button"
                    className="btn btn-success px-4"
                    onClick={() => {
                      if (isDataChanged) {
                        handleSubmit();
                      } else {
                        navigate("/manage-customer");
                      }
                    }}
                  >
                    Submit
                  </button>
                  {/* </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Branding;
